import { ethers } from "ethers";
import React, { Component } from "react";
import getContract, {getAutoRunContract} from "../services/contract";
import withWrapper from '../helpers/withWrapper'
import getWallet from '../services/wallet';

class Login extends Component {
  state = {
    id: '',
    userAddress: '',
    isConnected: false,
    lastId: 0,
    totalValue: 0,
    totalAutorunValue: 0
  };

  connectWallet = async () => {
    const wallet = await getWallet();
    if(!wallet.isReadOnly) {
        const browserAddresses = await wallet.provider.listAccounts();
        this.setState({ userAddress: browserAddresses[0], isConnected: true })
    } else {
        alert('Wallet not connected')
    }
  }

  async componentDidMount() {
    const contract = await getContract();
    const lastId = ethers.BigNumber.from(await contract.lastIDCount()).toNumber();
    const autorunContract = await getAutoRunContract();
    const valueInvestedBN = await contract.totalValueInvested();
    const autorunTotalInvestedBN = await autorunContract.totalValueInvested();
    const totalInvested = +ethers.utils.formatUnits(valueInvestedBN, "mwei");
    const autorunTotalInvested = +ethers.utils.formatUnits(autorunTotalInvestedBN, "mwei");
    // const lastId = ethers.BigNumber.from().toNumber();
    this.setState({lastId, totalValue: totalInvested + autorunTotalInvested, totalAutorunValue: autorunTotalInvested})
    console.log(this.state);
  }

  handleViewClick = async () => {
    const contract = await getContract();
    const id = this.state.id;
    const lastId = ethers.BigNumber.from(await contract.lastIDCount()).toNumber();
    if(lastId < id) {
      alert(`User Id ${id} not found`);
      return;
    }
    this.props.router.navigate('/dashboard/' + id);
  };

  handleLogin = async () => {
    const wallet = await getWallet();
    if(!wallet.isReadOnly) {
        const browserAddresses = await wallet.provider.listAccounts();
        const contract = await getContract();
        const id = ethers.BigNumber.from(await contract.getIdByAddress(browserAddresses[0])).toNumber();
        if(id == 0) {
          alert('No id found with your connected wallet make sure switch to joined account on metamask');
          return;
        }
        this.props.router.navigate('/dashboard/' + id);
    }
  };

  render() {
    return (
      <div id="__next1" style={{ height: "100vh" }}>
        <div
          style={{ backgroundImage: "url('/logo/bg3.jpeg')" }}
          className="flex relative bg-main-bg flex-col items-center justify-center w-full min-h-screen text-white-500 px-10 sm:px-0 overflow-hidden pt-16"
        >
          <div
            style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
            className="fixed top-0 left-1/2 -translate-x-1/2 flex justify-center w-full px-10 py-2.5 lg:p-0 lg:max-h-screen z-999999"
          >
            <div
              style={{ background: "black" }}
              className="flex justify-between items-center rounded-mini max-w-desktop-preview-bar w-full px-5 py-2 shadow-preview-bar lg:pl-10 sm:pl-5 lg:py-2.5 lg:rounded-none lg:rounded-b-mini lg:pr-0 false"
            >
              <div className="flex w-full overflow-hidden items-center justify-between space-x-2.5 lg:items-start ">
                <div className="w-full flex justify-start items-center space-x-5 lg:flex-col lg:h-full lg:items-start lg:space-x-0 lg:space-y-7.5">
                  <div className="flex items-center  false lg:w-full lg:pr-10 sm:pr-5">
                    <a
                      href="/"
                      className="header-link"
                      style={{ marginRight: "95px" }}
                    >
                      <img
                        style={{ width: "50px", height: "50px" }}
                        src="/logo/TBIGIF.gif"
                        className="light"
                        alt=""
                      />
                      <img
                        style={{ width: "50px", height: "50px" }}
                        src="/logo/TBIGIF.gif"
                        className="dark"
                        alt=""
                      />
                    </a>
                  </div>
                </div>
                {this.state.userAddress == "" ? (
                  <button
                    className="flex justify-center items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none px-5 py-3 bg-main-bg hover:bg-black-500 whitespace-nowrap lg:hidden"
                    onClick={this.connectWallet}
                    id="connectWallet"
                  >
                    Connect wallet
                  </button>
                ) : (
                  <div className="flex justify-center items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none px-5 py-2.5 hover:bg-line-gray active:bg-active-gray text-white font-normal rounded items-center">
                    {this.state.userAddress != ""
                      ? this.state.userAddress.slice(0, 4) +
                        "..." +
                        this.state.userAddress.slice(
                          this.state.userAddress.length - 4,
                          this.state.userAddress.length
                        )
                      : ""}
                  </div>
                )}
              </div>
              <div className="flex lg:justify-end lg:ml-auto lg:pr-10 sm:pr-5"></div>
            </div>
          </div>
          <div
            style={{
              padding: "0 40px 40px",
              marginBottom: "50px",
              maxWidth: "900px",
              background: "rgba(22,22,32,.5)",
            }}
            className="flex flex-col flex-1 w-full max-w-desktop-login mt-7.5 sm:mt-0 rounded-lg"
          >
            <div className="flex flex-col">
              <div className="flex flex-col mb-15 mt-10 pb-5">
                <div className="flex flex-col">
                  <div className="flex w-full items-start justify-between space-x-10 lg:space-x-2.5 sm:space-x-0 sm:space-y-5 sm:flex-col sm:px-5">
                    <div className="flex flex-col sm:px-5">
                      <span className="text-white text-3xl font-bold">
                        Sign In
                      </span>
                      <span className="text-white text-base mt-1 mb-7.5">
                        Enter ID below to view Matrix and Insights. OR
                        Click Sign in to Connect with Wallet.
                      </span>
                    </div>
                    <div
                      style={{
                        background:
                          "radial-gradient(circle at 24.1% 68.8%, rgb(50, 50, 50) 0%, rgb(0, 0, 0) 99.4%)",
                      }}
                      className="relative flex flex-grow max-w-500px w-full h-full flex-col p-5 justify-between bg-black-light rounded sm:max-w-full"
                    >
                      <div className="md:flex flex-wrap justify-between false">
                        <div className="flex justify-between items-center text-left w-full ">
                          <div className="flex flex-wrap text-white mr-1.5">
                            <div className="mr-1.5">Not a member yet? </div>
                            
                          </div>
                          <a id="hideSignUpButton">
                            <button
                              style={{
                                backgroundColor: "#E5D858",
                                fontSize: "22px",
                                color: "black",
                              }}
                              onClick={() =>
                                this.props.router.navigate('/join')
                              }
                              className="flex justify-center items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none py-0 px-2.5 bg-blue-600 text-white rounded !leading-30px hover:bg-blue-500 active:bg-active-main-blue w-max flex-shrink-0"
                            >
                              Join now
                            </button>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex sm:flex-col">
                    <div
                      style={{ borderRadius: "0 3rem 3rem 3rem" }}
                      className="flex flex-col flex-1 sm:w-full rounded sm:rounded-none sm:p-5 sm:mr-0 sm:mb-5"
                    >
                      <span
                        style={{ fontSize: "25px" }}
                        className="text-white mb-3"
                      >
                        ID
                      </span>
                      <div className="flex sm:flex-col">
                        <input
                          onChange={(e) =>
                            this.setState({ id: e.target.value })
                          }
                          value={this.state.id}
                          style={{
                            background: "white",
                            color: "black",
                            fontSize: "24px",
                          }}
                          className="w-full bg-white-100 border-2 border-transparent text-white rounded-mini py-3 px-2 outline-none focus:border-2 focus:border-black flex-1 mr-5 sm:mr-0 sm:mb-3.5 py-2"
                          id="idbyPlan"
                          type="number"
                        />
                        <button
                          style={{ backgroundColor: "black", fontSize: "26px" }}
                          onClick={this.handleViewClick}
                          className="flex justify-center items-center text-center text-white text-base font-bold text-black rounded-mini sm:text-sm outline-none px-5 py-3 bg-blue-500 hover:bg-blue-700 active:bg-active-main-blue rounded-mini"
                        >
                          View
                        </button>
                        <button
                          style={{ backgroundColor: "black", fontSize: "26px" }}
                          onClick={this.handleLogin}
                          className="flex justify-center ml-10 sm:ml-0 sm:mt-5 items-center text-white text-center text-base font-bold text-black rounded-mini sm:text-sm outline-none px-5 py-3 bg-blue-500 hover:bg-blue-700 active:bg-active-main-blue rounded-mini"
                        >
                          Sign In
                        </button>
                      </div>
                    </div>
                    {/* <div className="w-1/3 min-w-320px sm:w-full sm:px-5">
                        <div style={{ backgroundColor: "#000000", backgroundImage: "linear-gradient(147deg, #000000 0%, #2c3e50 74%)", borderRadius: "0 3rem 3rem 3rem"}} className="flex flex-col w-full rounded bg-black-light p-7.5 relative">
                          
                            <button  style={{backgroundColor: "#E5D858", fontSize: '26px', color: "black"}}
                            onClick={this.handleLogin} className="flex justify-center items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none px-5 py-3 bg-main-bg hover:bg-hover-main-bg active:bg-active-main-bg sm:w-full">
                              Auto-Login
                            </button>
                        </div>
                      </div> */}
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-10 mt-5 lg:grid-cols-1 lg:gap-5 z-10 sm:px-5">
                <div className="w-full">
                  <div
                    style={{
                      backgroundColor: "#1B5C7E",
                      borderRadius: "0 3rem 3rem 3rem",
                    }}
                    className="flex flex-col items-center p-5 bg-black-light rounded desktop-infoblock-base sm:mobile-infoblock-base"
                  >
                    <div className="flex ">
                      <span className="text-white ext-xl sm:whitespace-nowrap">
                        Total Joinings
                      </span>
                    </div>
                    <span className="text-white text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">
                      {this.state.lastId}
                    </span>
                  </div>
                </div>
                <div
                  style={{
                    backgroundColor: "#1B5C7E",
                    borderRadius: "0 3rem 3rem 3rem",
                  }}
                  className="flex flex-col items-center p-5 bg-black-light rounded desktop-infoblock-base sm:mobile-infoblock-base"
                >
                  <div className="flex">
                    <span className="text-white text-xl sm:whitespace-nowrap">
                      Total Invested (USDT)
                    </span>
                  </div>
                  <span className="text-white text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">
                    {this.state.totalValue}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer
          style={{
            zIndex: "1000",
            backgroundColor: "#406AFF",
            backgroundImage: "url('/logo/bg2.jpeg')",
          }}
          className="diamond-footer"
        >
          <div className="footer-widget-area">
            <div className="flex justify-center">
              <div className="row">
                <div className="col-lg-3 col-md-4 widget-area logo_clear_first">
                  <div
                    className="widget widget-html"
                    style={{ paddingTop: "30px" }}
                  ></div>
                </div>
                <div className="lg:col-span-6 md:col-span-4 widget-area">
                  <div className="widget widget-html text-center">
                    <h2 className="widget-title">Social Media</h2>
                    <div className="socials">
                      <ul style={{ color: "white" }}>
                        {/* <li>
                          <a target="_blank" href="https://www.facebook.com/bxchain2023">
                            <i style={{ color: "#406AFF" }} className="fab fa-facebook-f"></i>
                          </a>
                        </li>
                        <li>
                          <a target="_blank" href="https://twitter.com/bxchain2023">
                            <i style={{ color: "#406AFF" }} className="fab fa-twitter"></i>
                          </a>
                        </li> */}
                        <li>
                          <a target="_blank" href="https://t.me/tbi_2024">
                            <i
                              style={{ color: "#406AFF" }}
                              className="fab fa-telegram-plane"
                            ></i>
                          </a>
                        </li>

                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default withWrapper(Login);